import { render, staticRenderFns } from "./SCardSection.vue?vue&type=template&id=0cfcafe7&scoped=true&"
import script from "./SCardSection.vue?vue&type=script&lang=js&"
export * from "./SCardSection.vue?vue&type=script&lang=js&"
import style0 from "./SCardSection.vue?vue&type=style&index=0&id=0cfcafe7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfcafe7",
  null
  
)

export default component.exports